module.exports = __webpack_public_path__ + "img/58.40397a97.jpg";